<template>
  <SSO-btn
    :logo="require('@/assets/google_signin_logo.svg')"
    provider-name="Google"
    @click="loginWithGoogle"
    :loading="loading"
  >
  </SSO-btn>
</template>

<script>
import SSOBtn from "@/components/SSOBtn";

export default {
  data() {
    return {
      loading: false,
    };
  },

  components: {
    SSOBtn,
  },

  methods: {
    async loginWithGoogle() {
      this.loading = true;
      this.$firebase
        .auth()
        .setPersistence(this.$firebase.auth.Auth.Persistence.NONE);
      const provider = new this.$firebase.auth.GoogleAuthProvider();
      provider.addScope("email");

      try {
        await this.$firebase.auth().signInWithPopup(provider);
        const user = this.$firebase.auth().currentUser.providerData[0];
        const idToken = await this.$firebase
          .auth()
          .currentUser.getIdToken(true);
        const picture = user.photoURL;
        await this.$store.dispatch("Auth/loginWithSSO", {
          uid: this.$firebase.auth().currentUser.uid,
          idToken,
          name: user.displayName,
          email: user.email,
          profilePicture: picture === null ? undefined : picture,
          provider: "google",
        });
        this.$logEvent("google_sso_successful");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_google_sso_successful");
        }
      } catch (error) {
        if (error.code === "auth/popup-closed-by-user") return;

        if (error.code === "auth/account-exists-with-different-credential") {
          this.$store.dispatch("snackBar/showSnack", {
            text: "Your email was registered using Facebook, please use that for signing in.",
            color: "error",
          });
          return;
        }

        this.$store.dispatch("snackBar/showSnack", {
          text: "Something went wrong. Please try again.",
          color: "error",
        });
        throw error;
      } finally {
        this.loading = false;
      }

      if (this.$store.state.Auth.checkStatus === "HOME")
        // this.$router.push({
        //   name: "HomePage",
        //   params: { id: localStorage.getItem("user_id") },
        // });
        this.$router.push({
          name: "mainPage",
        });
    },
  },
};
</script>
